export default {"src":"/_next/static/media/windows-replacement.140910d5.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};